import AGREGAR_OFICIO_AUTORIZACION_DETALLE from '@/graphql/mutations/administracion/programacion/oficiosautorizacion/agregarOficioAutorizacionDetalles.gql';
import REMOVER_OFICIO_AUTORIZACION_DETALLE from '@/graphql/mutations/administracion/programacion/oficiosautorizacion/removerOficioAutorizacionDetalle.gql';
import FUENTES_FINANCIERAS from '@/graphql/querys/administracion/catalogos/fuentesfinancieras/fuentesFinancieras.gql';

export default {
  apollo: {
    fuentesFinancieras: {
      query: FUENTES_FINANCIERAS,
    },
  },
  methods: {
    // agregar Oficio Autorización Detalle
    async mixAgregarOficioDetalle() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const detalles = [this.detalle];
      await this.$apollo
        .mutate({
          mutation: AGREGAR_OFICIO_AUTORIZACION_DETALLE,
          variables: { detalles },
          refetchQueries: ['filtrarOficiosAutorizacion', 'oficioAutorizacion'],
          awaitRefetchQueries: true,
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarOficioDetalle() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_OFICIO_AUTORIZACION_DETALLE,
        variables: {
          id: this.oficioAutorizacionDetalleEliminar.id,
        },
        refetchQueries: ['filtrarOficiosAutorizacion', 'oficioAutorizacion'],
        awaitRefetchQueries: true,
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

  },
};
